import PaymentGatewayConfigurationsIcon from '@material-ui/icons/ViewList';

import PaymentGatewayConfigurationsList from './PaymentGatewayConfigurationsList';

export default {
  list: PaymentGatewayConfigurationsList,
  icon: PaymentGatewayConfigurationsIcon,
};
